<div mat-dialog-content>
    <app-follow-up-form mode="create"
                        [opportunity]="opportunity"
                        [formGroup]="formGroup"
    ></app-follow-up-form>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="formGroup.invalid || saving">Save</button>
</div>